import React from "react";
import {
  ToggleContainer,
  SwitchThumb,
  Label,
} from "../styles/sharedComponentStyles";
import { useThemeToggle } from "../utils/ThemeContext";

const ThemeToggleSwitch = () => {
  const { mode, toggleTheme } = useThemeToggle();

  return (
    <ToggleContainer mode={mode} onClick={toggleTheme}>
      <Label>{mode === "light" ? "Light" : "Dark"}</Label>
      <SwitchThumb mode={mode}>{mode === "light" ? "☀️" : "🌙"}</SwitchThumb>
    </ToggleContainer>
  );
};

export default ThemeToggleSwitch;
